import * as yup from 'yup';
import { TestContext } from 'yup';

import { makeValidateSync } from '@cast/utils';

import { CustomLabelsModel } from 'features/cluster/autoscaler/node-selection-templates/types';

import {
  MAX_GPU_TIME_SLICING_REPLICAS,
  MIG_PARTITION_SIZE_PATTERN,
  MIG_PARTITION_SIZE_PATTERN_MESSAGE,
} from '../constants';

const validateUniqueKeys = (value: string, context: TestContext): boolean => {
  const allLabels: (CustomLabelsModel | undefined)[] | undefined =
    context.from?.[1].value._customLabels;

  if (!allLabels) {
    return true;
  }

  const amountOfSameKeys = allLabels.reduce(
    (acc, label) => (label?.key === value ? acc + 1 : acc),
    0
  );

  return amountOfSameKeys <= 1;
};

export const validate = makeValidateSync(
  yup.object().shape({
    replicas: yup
      .number()
      .integer('Replicas must be an integer')
      .min(1, 'Replicas must be at least 1')
      .max(
        MAX_GPU_TIME_SLICING_REPLICAS,
        `Replicas must be at most ${MAX_GPU_TIME_SLICING_REPLICAS}`
      )
      .typeError('Replicas must be a number')
      .nullable()
      .notRequired(),
    partitionSize: yup
      .string()
      .trim()
      .matches(MIG_PARTITION_SIZE_PATTERN, {
        message: MIG_PARTITION_SIZE_PATTERN_MESSAGE,
        excludeEmptyString: true,
      })
      .notRequired()
      .nullable(),
    shouldTaint: yup.boolean(),
    _customTaints: yup.array().when('shouldTaint', {
      is: true,
      then: (schema) =>
        schema.of(
          yup.object().shape({
            key: yup.string().required('Taint key is required'),
            value: yup.string().required('Taint value is required'),
          })
        ),
    }),
    shouldUseCustomLabels: yup.boolean(),
    _customLabels: yup.array().when('shouldUseCustomLabels', {
      is: true,
      then: (schema) =>
        schema.of(
          yup.object().shape({
            key: yup
              .string()
              .required('Label key is required')
              .test('unique-key', 'This key is not unique', validateUniqueKeys),
            value: yup.string().required('Label value is required'),
          })
        ),
    }),
  })
);
